module.exports = __webpack_public_path__ + "img/payment-logos-ozow.592a43bd.png";